module.exports = __webpack_public_path__ + "img/juego1.4a338f0e.png";